import React from "react";
import { Image } from "antd";

export const PreviewUpload = ({ value, className, listType, showUploadList, onPreview }) => {
    return (
        <Image.PreviewGroup>
            {(value || []).map(item => {
                return <Image width={85} height={85} src={item.url} />;
            })}
        </Image.PreviewGroup>
    );
};
